import RcSlider, { SliderProps as RcSliderProps, SliderRef } from 'rc-slider/lib/Slider';

export type SliderProps = RcSliderProps<number>;

// Need to export our own to account for rc-slider's crappy type definitions
// https://github.com/react-component/slider/issues/835
export const Slider = RcSlider as React.ForwardRefExoticComponent<SliderProps & React.RefAttributes<SliderRef>>;
